/**
 * Used for heap tracking in specifying what method the user used to select
 * a color. Either 'hexPicker' or 'colorChip' in Flowcode and Flowpage
 */
export enum ColorSelectionMethods {
  HEX_PICKER = 'hexPicker',
  COLOR_CHIP = 'colorChip',
  CONFIG = 'config'
}
